import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const Sphere = styled.span`
  display: block;
  border-radius: 50%;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  background: radial-gradient(circle at 30% 30%, ${props => props.color}, #000);
`
class Ball extends React.Component {
  render() {
    return <Sphere {...this.props} />
  }
}

Ball.defaultProps = {
  size: 16,
  color: '#dddddd'
}

Ball.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string
}

export default Ball



// WEBPACK FOOTER //
// ./src/components/widgets/Ball.js